import * as React from 'react';
import { IOutsideClickedHandler, IOverlayClass } from './Overlay';

interface IOverlayProps extends React.PropsWithChildren {
	overlay: IOverlayClass;
}

export class OverlayContainer extends React.Component<IOverlayProps> {
	private outsideClickedRef: IOutsideClickedHandler;
	private overlayContainer: React.RefObject<HTMLDivElement>;
	public constructor(props: IOverlayProps) {
		super(props);
		this.overlayContainer = React.createRef();
	}

	public render() {
		const Overlay = this.props.overlay;
		return <React.Fragment>
			<div className="background-blur">
				{this.props.children}
			</div>
			<div
				className="overlay-container"
				onClick={(e) => { this.outsideClickedRef(); e.stopPropagation(); }}
				ref={this.overlayContainer}
			>
				<div className="overlay-container__inner" onClick={(e) => e.stopPropagation()}>
					<Overlay
						outsideClickedRef={(r: IOutsideClickedHandler) => this.outsideClickedRef = r}
						scrollTop={this.scrollTop} />
				</div>
			</div>
		</React.Fragment>;
	}

	private scrollTop = () => {
		if (this.overlayContainer && this.overlayContainer.current) {
			this.overlayContainer.current.scrollTop = 0;
		}
	}
}
